(() => {
  const root = document.querySelector('[data-lyfe-shop]');
  if (!root) return;
  const grid = root.querySelector('[data-shop-grid]');
  const empty = root.querySelector('[data-shop-empty]');
  const updateState = () => {
    const total = grid.querySelectorAll('[data-shop-product]').length;
    if (empty) empty.hidden = total > 0;
  };
  const loadCatalogue = async () => {
    const seen = new Set([...grid.querySelectorAll('[data-shop-product]')].map(card => card.dataset.productHandle));
    let nextPage = root.dataset.nextPage;
    try {
      while (nextPage) {
        const url = new URL(nextPage, window.location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Catalogue unavailable');
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = documentFragment.querySelector('[data-lyfe-shop]');
        if (!nextRoot) throw new Error('Catalogue unavailable');
        nextRoot.querySelectorAll('[data-shop-product]').forEach(card => {
          if (seen.has(card.dataset.productHandle)) return;
          seen.add(card.dataset.productHandle);
          grid.append(card);
        });
        nextPage = nextRoot.dataset.nextPage;
        updateState();
      }
    } catch {
      root.dataset.catalogueIncomplete = 'true';
    } finally {
      grid.setAttribute('aria-busy', 'false');
      updateState();
    }
  };
  document.addEventListener('click', event => {
    const sort = root.querySelector('[data-shop-sort]');
    if (sort?.open && !sort.contains(event.target)) sort.open = false;
  });
  updateState();
  loadCatalogue();
})();
